import { ettsBootstrap } from "./bootstrap";
import { roleLabel } from "./users";

/**
 * Auth — cookie-based (form login → `etts_access` HttpOnly JWT cookie).
 *
 * Přihlášený uživatel přichází ze server-injected bootstrapu (`window.__ETTS__.user`),
 * naplněného Thymeleaf shellem při každém načtení SPA. SPA tedy nedrží token v JS.
 *
 * Login: SPA login stránka POSTuje HTML form na `/admin/login` (plná navigace),
 * Spring autentizuje, nastaví cookie a přesměruje na `/app`. Failure → `/app/login?error`.
 * Logout: form POST na `/admin/logout`.
 */
export interface AuthUser {
  username: string;
  displayName?: string | null;
  roles: string[];
}

export function currentUser(): AuthUser | null {
  return ettsBootstrap().user;
}

export function isAuthenticated(): boolean {
  return currentUser() !== null;
}

/**
 * Podklad pro kartu účtu (patička sidebaru i horní lišta) — jedno mapování pro
 * obě místa, ať se nerozejdou.
 *
 * `AuthUser` nemá ani e-mail, ani avatar (přihlášení je lokální nebo z adresáře),
 * takže podtitulem je role. Iniciála se počítá tady, protože `Avatar` jich sám
 * nedovodí víc než z `alt` a my chceme stejný znak v obou instancích.
 */
export interface AccountDisplay {
  title: string;
  subtitle: string;
  initials: string;
}

export function accountDisplay(user: AuthUser): AccountDisplay {
  const title = user.displayName?.trim() || user.username;
  return {
    title,
    subtitle: user.roles.map(roleLabel).join(", "),
    initials: title.trim().charAt(0).toUpperCase() || "?",
  };
}

export function hasRole(role: string): boolean {
  const u = currentUser();
  if (!u) return false;
  const want = role.startsWith("ROLE_") ? role : `ROLE_${role}`;
  return u.roles.some((r) => r === role || r === want);
}
